import dayjs, { Dayjs } from "dayjs";
import { ClassRoomType } from "../../gql/graphql.ts";
import { ActivityPeriod, isWithinPeriod } from "./activityPeriod.ts";

export type TeacherClassRoomRecord = {
  id: string;
  type: ClassRoomType;
  is1on1?: boolean | null;
  userIds: string[];
  capacity: number;
  startUtc: string;
  endUtc: string;
  deletedAt?: string | null;
  lessonFeedbackCount?: number | null;
  progressCheckResultCount?: number | null;
};

function wasTaughtInPeriod(
  classRoom: TeacherClassRoomRecord,
  period: ActivityPeriod,
  now: Dayjs,
): boolean {
  return (
    !classRoom.deletedAt &&
    classRoom.userIds.length > 0 &&
    isWithinPeriod(dayjs(classRoom.startUtc), period) &&
    dayjs(classRoom.endUtc).isBefore(now)
  );
}

export function classRoomsTaughtInPeriod({
  classRooms,
  period,
  now,
}: {
  classRooms: TeacherClassRoomRecord[];
  period: ActivityPeriod;
  now: Dayjs;
}): TeacherClassRoomRecord[] {
  return classRooms.filter((classRoom) =>
    wasTaughtInPeriod(classRoom, period, now),
  );
}
